import { NgModule } from '@angular/core';
import { VafFinesFileUpload } from './vaf-fines-file-upload.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VafLogResponseComponentModule } from '../../components/vaf-log-response-component/vaf-log-response-component.component.module';
import { TableExtractionComponentModule } from '../../components/table-extraction/table-extraction.component.module';

@NgModule({
    declarations: [
        VafFinesFileUpload
    ],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        VafLogResponseComponentModule,
        TableExtractionComponentModule
    ],
    exports: [
        VafFinesFileUpload
    ]
})
export class VafFinesFileUploadModule { }